export const POST_UUID_PREFIX = 'PostUUID:';
